import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './TermsAndConditions.module.css';

const MainTitle = ({ title, subTitleLine }) => (
  <div className={styles.mainTitleWrapper}>
    <h2 className={styles.sectionTitle}>{title}</h2>
    <p className={styles.sectionSubtitle}>{subTitleLine}</p>
  </div>
);

function TermsAndConditions() {
  return (
    <section className={styles.termsSection} id="termsAndConditionsId">
      <div className={styles.containerCustom}>
        <MainTitle
          title={<FormattedMessage id="Terms.title" />}
          subTitleLine={<FormattedMessage id="Terms.subtitle" />}
        />

        <div className={styles.termsContainer}>
          {/* For Renters */}
          <div className={styles.termCategory}>
            <h2 className={styles.categoryTitle}>
              <FormattedMessage id="Terms.renters.title" />
            </h2>
            <div className={styles.termsList}>
              {[
                'Terms.renters.term1',
                'Terms.renters.term2',
                'Terms.renters.term3',
                'Terms.renters.term4',
                'Terms.renters.term5',
                'Terms.renters.term6',
                'Terms.renters.term7',
                'Terms.renters.term8',
              ].map((termId, index) => (
                <div className={styles.termItem} key={index}>
                  <div className={styles.termBullet}></div>
                  <p className={styles.termText}>
                    <FormattedMessage id={termId} />
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* For Lenders */}
          <div className={styles.termCategory}>
            <h2 className={styles.categoryTitle}>
              <FormattedMessage id="Terms.lenders.title" />
            </h2>
            <div className={styles.termsList}>
              {[
                'Terms.lenders.term1',
                'Terms.lenders.term2',
                'Terms.lenders.term3',
                //  'Terms.lenders.term4',
              ].map((termId, index) => (
                <div className={styles.termItem} key={index}>
                  <div className={styles.termBullet}></div>
                  <p className={styles.termText}>
                    <FormattedMessage id={termId} />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsAndConditions;
